var _g, _path, _path2, _path3, _g2, _g3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownvote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2136_65139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2303 19.9128C15.2303 21.2665 14.1328 22.3639 12.7791 22.3639C11.4254 22.3639 10.328 21.2665 10.328 19.9128L10.328 17.092C10.328 16.8514 10.3446 16.6116 10.3818 16.3718C10.3954 16.2842 10.409 16.1968 10.4174 16.1094C10.4442 15.8333 10.4115 15.4726 10.2238 15.2304L10.672 14.7981C8.42463 13.6499 6.88462 11.3019 6.88462 8.59195C6.88462 7.85776 6.99766 7.15014 7.20717 6.48575L7.94987 1.63611L13.9884 1.63611L13.9884 1.63816C17.7176 1.71846 20.7095 4.15024 20.7095 8.59195C20.7095 11.2029 19.4593 13.3049 17.5679 14.4901L17.5726 14.4938C17.4437 14.5833 17.2918 14.6744 17.1289 14.7721L17.1277 14.7728C16.5913 15.0944 15.9357 15.4874 15.5898 16.1301C15.2899 16.6873 15.2317 17.5917 15.2317 18.011L15.2303 18.0103L15.2303 19.9128Z",
    fill: "url(#paint0_linear_2136_65139)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2303 19.9128C15.2303 21.2665 14.1328 22.3639 12.7791 22.3639C11.4254 22.3639 10.328 21.2665 10.328 19.9128L10.328 17.092C10.328 16.8514 10.3446 16.6116 10.3818 16.3718C10.3954 16.2842 10.409 16.1968 10.4174 16.1094C10.4442 15.8333 10.4115 15.4726 10.2238 15.2304L10.672 14.7981C8.42463 13.6499 6.88462 11.3019 6.88462 8.59195C6.88462 7.85776 6.99766 7.15014 7.20717 6.48575L7.94987 1.63611L13.9884 1.63611L13.9884 1.63816C17.7176 1.71846 20.7095 4.15024 20.7095 8.59195C20.7095 11.2029 19.4593 13.3049 17.5679 14.4901L17.5726 14.4938C17.4437 14.5833 17.2918 14.6744 17.1289 14.7721L17.1277 14.7728C16.5913 15.0944 15.9357 15.4874 15.5898 16.1301C15.2899 16.6873 15.2317 17.5917 15.2317 18.011L15.2303 18.0103L15.2303 19.9128Z",
    fill: "url(#paint1_radial_2136_65139)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2303 19.9128C15.2303 21.2665 14.1328 22.3639 12.7791 22.3639C11.4254 22.3639 10.328 21.2665 10.328 19.9128L10.328 17.092C10.328 16.8514 10.3446 16.6116 10.3818 16.3718C10.3954 16.2842 10.409 16.1968 10.4174 16.1094C10.4442 15.8333 10.4115 15.4726 10.2238 15.2304L10.672 14.7981C8.42463 13.6499 6.88462 11.3019 6.88462 8.59195C6.88462 7.85776 6.99766 7.15014 7.20717 6.48575L7.94987 1.63611L13.9884 1.63611L13.9884 1.63816C17.7176 1.71846 20.7095 4.15024 20.7095 8.59195C20.7095 11.2029 19.4593 13.3049 17.5679 14.4901L17.5726 14.4938C17.4437 14.5833 17.2918 14.6744 17.1289 14.7721L17.1277 14.7728C16.5913 15.0944 15.9357 15.4874 15.5898 16.1301C15.2899 16.6873 15.2317 17.5917 15.2317 18.011L15.2303 18.0103L15.2303 19.9128Z",
    fill: "url(#paint2_radial_2136_65139)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2303 19.9128C15.2303 21.2665 14.1328 22.3639 12.7791 22.3639C11.4254 22.3639 10.328 21.2665 10.328 19.9128L10.328 17.092C10.328 16.8514 10.3446 16.6116 10.3818 16.3718C10.3954 16.2842 10.409 16.1968 10.4174 16.1094C10.4442 15.8333 10.4115 15.4726 10.2238 15.2304L10.672 14.7981C8.42463 13.6499 6.88462 11.3019 6.88462 8.59195C6.88462 7.85776 6.99766 7.15014 7.20717 6.48575L7.94987 1.63611L13.9884 1.63611L13.9884 1.63816C17.7176 1.71846 20.7095 4.15024 20.7095 8.59195C20.7095 11.2029 19.4593 13.3049 17.5679 14.4901L17.5726 14.4938C17.4437 14.5833 17.2918 14.6744 17.1289 14.7721L17.1277 14.7728C16.5913 15.0944 15.9357 15.4874 15.5898 16.1301C15.2899 16.6873 15.2317 17.5917 15.2317 18.011L15.2303 18.0103L15.2303 19.9128Z",
    fill: "url(#paint3_radial_2136_65139)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2136_65139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32396 4.43912C6.32396 4.79048 6.4159 5.11945 6.57607 5.40133C5.93484 5.7225 5.49219 6.40587 5.49219 7.19701C5.49219 7.81219 5.75984 8.36221 6.18038 8.72744C5.77722 9.08467 5.52143 9.61716 5.52143 10.2119C5.52143 10.9913 5.96067 11.6638 6.59519 11.9751C6.30665 12.3172 6.13168 12.766 6.13168 13.2574C6.13168 14.3306 6.96629 15.2005 7.99584 15.2005H10.0606C11.0902 15.2005 11.9248 14.3306 11.9248 13.2574C11.9248 12.6588 11.6651 12.1234 11.2568 11.7669C11.7083 11.4114 12.0001 10.8472 12.0001 10.2119C12.0001 9.61001 11.7381 9.07186 11.3265 8.71463C11.7386 8.34941 12.0001 7.80504 12.0001 7.19701C12.0001 6.65128 11.7894 6.15683 11.4483 5.79717C11.7886 5.45346 12.0001 4.97203 12.0001 4.43912C12.0001 3.39482 11.1879 2.54825 10.1861 2.54825H8.13797C7.13612 2.54825 6.32396 3.39482 6.32396 4.43912Z",
    fill: "#E69E12"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2136_65139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0932 14.2376C14.3607 12.5572 11.6185 13.7372 10.9079 14.2376L10.2773 13.4269C14.3128 11.5052 16.4627 13.1567 17.0932 14.2376Z",
    fill: "#F8A047"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.02686,
    y: 15.7594,
    width: 4.33815,
    height: 6.74067,
    rx: 2.16908,
    transform: "rotate(-90 5.02686 15.7594)",
    fill: "url(#paint4_linear_2136_65139)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.02686,
    y: 15.7594,
    width: 4.33815,
    height: 6.74067,
    rx: 2.16908,
    transform: "rotate(-90 5.02686 15.7594)",
    fill: "url(#paint5_linear_2136_65139)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.02686,
    y: 15.7594,
    width: 4.33815,
    height: 6.74067,
    rx: 2.16908,
    transform: "rotate(-90 5.02686 15.7594)",
    fill: "url(#paint6_radial_2136_65139)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.02686,
    y: 15.7594,
    width: 4.33815,
    height: 6.74067,
    rx: 2.16908,
    transform: "rotate(-90 5.02686 15.7594)",
    fill: "url(#paint7_radial_2136_65139)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.02686,
    y: 15.7594,
    width: 4.33815,
    height: 6.74067,
    rx: 2.16908,
    transform: "rotate(-90 5.02686 15.7594)",
    fill: "url(#paint8_radial_2136_65139)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25073,
    y: 5.85753,
    width: 4.22142,
    height: 6.60453,
    rx: 2.11071,
    transform: "rotate(-90 5.25073 5.85753)",
    fill: "url(#paint9_linear_2136_65139)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25073,
    y: 5.85753,
    width: 4.22142,
    height: 6.60453,
    rx: 2.11071,
    transform: "rotate(-90 5.25073 5.85753)",
    fill: "url(#paint10_radial_2136_65139)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25073,
    y: 5.85753,
    width: 4.22142,
    height: 6.60453,
    rx: 2.11071,
    transform: "rotate(-90 5.25073 5.85753)",
    fill: "url(#paint11_radial_2136_65139)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25073,
    y: 5.85753,
    width: 4.22142,
    height: 6.60453,
    rx: 2.11071,
    transform: "rotate(-90 5.25073 5.85753)",
    fill: "url(#paint12_radial_2136_65139)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 4.28296,
    y: 9.04793,
    width: 4.44515,
    height: 7.57235,
    rx: 2.22258,
    transform: "rotate(-90 4.28296 9.04793)",
    fill: "url(#paint13_linear_2136_65139)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 4.28296,
    y: 9.04793,
    width: 4.44515,
    height: 7.57235,
    rx: 2.22258,
    transform: "rotate(-90 4.28296 9.04793)",
    fill: "url(#paint14_radial_2136_65139)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 4.28296,
    y: 9.04793,
    width: 4.44515,
    height: 7.57235,
    rx: 2.22258,
    transform: "rotate(-90 4.28296 9.04793)",
    fill: "url(#paint15_radial_2136_65139)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 4.28296,
    y: 9.04793,
    width: 4.44515,
    height: 7.57235,
    rx: 2.22258,
    transform: "rotate(-90 4.28296 9.04793)",
    fill: "url(#paint16_radial_2136_65139)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 4.31689,
    y: 12.3648,
    width: 4.34788,
    height: 7.5383,
    rx: 2.17394,
    transform: "rotate(-90 4.31689 12.3648)",
    fill: "url(#paint17_linear_2136_65139)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 4.31689,
    y: 12.3648,
    width: 4.34788,
    height: 7.5383,
    rx: 2.17394,
    transform: "rotate(-90 4.31689 12.3648)",
    fill: "url(#paint18_radial_2136_65139)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 4.31689,
    y: 12.3648,
    width: 4.34788,
    height: 7.5383,
    rx: 2.17394,
    transform: "rotate(-90 4.31689 12.3648)",
    fill: "url(#paint19_radial_2136_65139)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 4.31689,
    y: 12.3648,
    width: 4.34788,
    height: 7.5383,
    rx: 2.17394,
    transform: "rotate(-90 4.31689 12.3648)",
    fill: "url(#paint20_radial_2136_65139)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3301 21.8111C14.8797 21.3616 15.2305 20.6781 15.2305 19.9128L15.2305 19.7696L14.1226 19.7696C14.1187 19.9171 14.1261 20.2948 14.1866 20.6256L14.1991 20.6937C14.2605 21.0269 14.3309 21.4089 14.3301 21.8111Z",
    fill: "url(#paint21_linear_2136_65139)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3301 21.8111C14.8797 21.3616 15.2305 20.6781 15.2305 19.9128L15.2305 19.7696L14.1226 19.7696C14.1187 19.9171 14.1261 20.2948 14.1866 20.6256L14.1991 20.6937C14.2605 21.0269 14.3309 21.4089 14.3301 21.8111Z",
    fill: "url(#paint22_radial_2136_65139)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2136_65139",
    x: 6.88452,
    y: 1.63611,
    width: 14.325,
    height: 20.7278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.584314 0 0 0 0 0.380392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2136_65139"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2136_65139",
    x: 3.49219,
    y: 0.548248,
    width: 10.5078,
    height: 16.6523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2136_65139"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2136_65139",
    x: 8.77734,
    y: 11.0428,
    width: 9.81592,
    height: 4.69479,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_2136_65139"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2136_65139",
    x1: 19.9405,
    y1: 6.07877,
    x2: 9.06958,
    y2: 22.3639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E99A30"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1302 5.48575) rotate(151.39) scale(5.45519 6.26015)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF163",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9216 19.5628) scale(3.48297 7.47388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE14F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9649 7.66104) rotate(90) scale(15.0171 9.70419)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.902214,
    stopColor: "#D87E83",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99262,
    stopColor: "#D87E83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2136_65139",
    x1: 7.19593,
    y1: 15.7594,
    x2: 7.19593,
    y2: 22.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC9B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2136_65139",
    x1: 4.76266,
    y1: 19.1297,
    x2: 6.16994,
    y2: 19.1297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D58191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D67F8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.6916 21.4914) rotate(-90) scale(1.93564 1.50267)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE160",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.41154 18.7113) rotate(180) scale(0.698469 3.67378)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF7F02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF7F02",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.19593 21.2461) rotate(-91.3531) scale(5.48823 6.0032)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.807914,
    stopColor: "#D8A96F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A96F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2136_65139",
    x1: 6.25885,
    y1: 6.53843,
    x2: 8.01756,
    y2: 11.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE27"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.91385 9.09367) scale(0.801283 3.30138)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69510",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.09063 11.2485) rotate(-90) scale(2.08871 1.78677)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE65",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.36144 11.2334) rotate(-91.3438) scale(5.37737 5.84169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.807914,
    stopColor: "#D8A96F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A96F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2136_65139",
    x1: 5.3445,
    y1: 9.8286,
    x2: 7.50075,
    y2: 15.8286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE27"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.98122 12.7583) scale(0.84375 3.78516)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69510",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.92735 15.1703) rotate(-90) scale(2.0117 1.58049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE65",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.50554 15.2116) rotate(-91.2342) scale(6.1651 6.15156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.807914,
    stopColor: "#D8A96F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A96F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2136_65139",
    x1: 6.49083,
    y1: 12.3648,
    x2: 6.49083,
    y2: 19.1366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE27"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.12555 15.0235) scale(1.78526 5.95088)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E48747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E48747",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.90342 18.4596) rotate(-90) scale(2.00265 1.54591)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE65",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.49083 18.5007) rotate(-91.2127) scale(6.13732 6.01699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.807914,
    stopColor: "#D8A96F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A96F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2136_65139",
    x1: 15.2305,
    y1: 19.5328,
    x2: 15.2305,
    y2: 22.1605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC99F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2136_65139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9501 20.4402) rotate(34.279) scale(1.35947 2.96737)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.549892,
    stopColor: "#F4BBC8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BBC8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownvote);
export default __webpack_public_path__ + "static/media/downvote.09e790c2.svg";
export { ForwardRef as ReactComponent };